import { Component } from '@angular/core';
import { MatInputModule, MatLabel } from "@angular/material/input";

@Component({
  selector: 'app-loading',
  imports: [MatInputModule, MatLabel],
  templateUrl: './loading.html',
  styleUrl: './loading.less',
  standalone: true
})
export class Loading {

}
